import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import { SET_CONNECTION_STATUS } from './constants';

const initialState = fromJS({
	connected: false,
});

export default handleActions({
	[SET_CONNECTION_STATUS]: (state: any, { payload }: any) => state.set('connected', payload.connected),
}, initialState);
